import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const PremiumIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="27"
    height="20"
    viewBox="0 0 27 20"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <g fill="#221F20">
      <path d="m13.5 20-8.88-9.72.19-.19 2.5-2.76 3.87 4.23 2.31-2.53 2.32 2.53 3.88-4.24 2.67 2.96-.16.2L13.5 20Zm-8.13-9.7 8.12 8.89 8.14-8.9-1.94-2.15-3.88 4.24-2.31-2.54-2.32 2.54-3.86-4.23-1.94 2.14Z" />
      <path d="m13.5 14.91-2.7-2.94 2.7-2.94 2.68 2.94-2.7 2.94h.01Zm-1.95-2.94 1.94 2.13 1.95-2.13-1.94-2.13-1.95 2.13ZM13.5 1.32 12.3 0h2.4l-1.2 1.32Z" />
      <path d="m15.8 12.38-2.68-2.94 4.1-4.48h.33l2.5 2.77-4.24 4.65Zm-1.93-2.94 1.94 2.12 3.5-3.83-1.93-2.14-3.51 3.85Z" />
      <path d="m19.69 8.14-2.43-2.68a.28.28 0 0 1-.1-.07L13.13.9l.82-.91h3.73l4.69 5.2-2.69 2.94Zm-2.16-3.17.1.07 2.06 2.28 1.94-2.12-4.2-4.65H14.2l-.33.36 3.66 4.06Z" />
      <path d="m18.12 14.91-2.68-2.94 6.19-6.77-4.7-5.2h5.38L27 5.2l-8.88 9.71Zm-1.94-2.94 1.94 2.13 8.14-8.9-4.2-4.65h-3.88l4.2 4.65-6.2 6.77Zm-5 .41L6.95 7.74l2.53-2.78h.3l4.1 4.48-2.7 2.94ZM7.69 7.74l3.49 3.82 1.94-2.12-3.5-3.84L7.7 7.74Z" />
      <path d="M17.46 5.5H9.54l-.28-.3L13.5.5l4.24 4.7-.28.3Zm-7.23-.54h6.54L13.5 1.33l-3.27 3.63Z" />
      <path d="M7.32 8.15 4.63 5.2 9.33 0h3.72l.82.91L10 5.21l.28.3h-.56l-2.4 2.64ZM5.37 5.2l1.95 2.13 2.17-2.38L13.13.91 12.8.55H9.56L5.37 5.2Z" />
      <path d="M8.86 14.91 0 5.21 4.69 0h5.37L5.37 5.2l6.18 6.77-2.7 2.94h.01ZM.74 5.21l8.12 8.89 1.95-2.13L4.63 5.2 8.83.55h-3.9L.74 5.2Z" />
    </g>
  </svg>
));
